export default {
  allFeaturesList: state => state.allFeaturesList,
  addedFeaturesList: state => state.addedFeaturesList,
  addedFeaturesListLoading: state => state.addedFeaturesListLoading,
  addedFeaturesListLoaded: state => state.addedFeaturesListLoaded,
  unitTypesList: state => state.unit_types,
  allCategoriesFeaturesList: state => state.allCategoriesFeaturesList,
};
